import { SimpleGrid } from "@mantine/core"
import { AuthenticatedAppShell } from "../../components/authenticated-app-shell"
import { AppCard, EmptyState, MetricCard, SectionHeader } from "../../components/ui"

export function SettingsPage() {
  return (
    <AuthenticatedAppShell eyebrow="Org settings" title="Settings">
      {(session) => (
        <>
          <SimpleGrid cols={{ base: 1, sm: 2 }}>
            <MetricCard label="Workspace" value={session.org?.name ?? "Workspace"} />
            <MetricCard label="Your role" value={session.org?.role ?? "owner"} />
          </SimpleGrid>

          <AppCard>
            <SectionHeader
              title="Workspace preferences"
              description="Billing, support access, and team management."
            />
            <EmptyState>Billing and workspace preferences are coming soon.</EmptyState>
          </AppCard>
        </>
      )}
    </AuthenticatedAppShell>
  )
}
